// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BaseServiceUrl : 'https://olios-recovery-web-dev.conurets.com/oliosrecovery-web',
  MAP_API: 'AIzaSyC0arKVAjPt4_nRYVTU2IzzmK2-jcSz594',
  //MAP_API: 'AIzaSyBkR0MQTy92ktHb0G-fn0Y2rW84dOoVQGc',
  //BaseServiceUrl : 'http://192.168.10.93:9090/oliosrecovery-web',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
